// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_NotFound-module_1RNiE","imgBlock":"imgBlock_NotFound-module_2tydI","header":"header_NotFound-module_qNOdJ","infoBlock":"infoBlock_NotFound-module_wY5mA"};